export default __webpack_public_path__ + "alberta-call.a59b6e6f069ad0faa7e4.svg";